import { render } from "./tot-button.vue?vue&type=template&id=1b963c6b"
import script from "./tot-button.vue?vue&type=script&lang=js"
export * from "./tot-button.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3011205126/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__